import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PrescriptionRealisePharmacieDetailTableMetierService} from './prescription-realise-pharmacie-detail-table.metier.service';
import {Autowired} from '@angular-ru/autowired';
import {SgiListLayoutComponent} from '@shared/behaviors/list-layout/sgi/sgi-list-layout.component';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-prescription-realise-pharmacie-detail-table',
  templateUrl: './prescription-realise-pharmacie-detail-table.component.html'
})

export class PrescriptionRealisePharmacieDetailTableComponent extends SgiListLayoutComponent implements OnInit {
  @Autowired() recuperationListeDonneesMetier: PrescriptionRealisePharmacieDetailTableMetierService;
  @Autowired() metierService: PrescriptionRealisePharmacieDetailTableMetierService;

  @Input() currentRow: any;
  @Input() responsePrescriptionsRealise: any;
  formGroup: FormGroup;
  typeRechercheCombo: any[] = [];
  placeholderInputSearch: string;
  @Output() responsePrescriptionsRealiseEvent = new EventEmitter<any>();


  constructor() {
    super();
    this.cols = [
      {field: 'dateRealisation', header: 'Date réalisation', type: () => 'date'},
      {field: 'libelle', header: 'Libelle'},
      {field: 'posologie', header: 'Posologie'},
      {field: 'quantite', header: 'Quantité'},
      {field: 'nomOrigine', header: 'Pharmacie'},
    ];
    this.tableActions = [];
    this.notRowActions = [];
  }

  ngOnInit(): void {
    this.initialiserTypeRechercheCombo();

    this.initFormulaire();

    this.formatTableListAddIndex(this.responsePrescriptionsRealise);
  }

  /**
   * Définition des arguments
   */
  defineArgs(): void {
    super.defineArgs();
    const arg = {...this.args};
    this.args = {...arg};
  }

  recuperationDonnees(data?: any) {
    const da = {...this.args, lazyLoadEvent: data, successMute: true, currentRow: this.currentRow};
    this.args = {...da};
    // tslint:disable-next-line:max-line-length
    this.metierService.requeteRecuperationListeDonnees(this.getAllRequestParam(), {...this.args}).subscribe((r_Prescriptions) => {
      const responsePrescriptionsRealise = r_Prescriptions.body;

      this.formatTableListAddIndex(responsePrescriptionsRealise);

      this.responsePrescriptionsRealiseEvent.emit(r_Prescriptions.body);
    });
  }

  formatTableListAddIndex(responseData) {
    if (responseData === undefined) {
      this.dataSource = [];
      this.totalRecords = 0;
      return;
    }
    this.dataSource = responseData.items;
    this.totalRecords = responseData.count;
    if (this.dataSource && this.dataSource.length > 0) {
      this.dataSource.forEach((dat, index) => {
        dat.id_key = index + 1;
      });
    }
  }

  initFormulaire() {
    this.formGroup = this.metierService.initialiserFormulaire(null);
  }

  initialiserTypeRechercheCombo() {
    this.placeholderInputSearch = 'Rechercher';
    this.typeRechercheCombo = [
      { label: 'Date realisation', value: 'date_realisation'},
      { label: 'Libelle', value: 'libelle'},
      { label: 'Quantité', value: 'quantite'},
      { label: 'Pharmacie', value: 'pharmacie'},

    ];
  }

  handleChangeTypeRecherche(event: any) {
    if (event.value === null) {
      this.placeholderInputSearch = 'Rechercher';

      this.formGroup.patchValue({ inputSearch: null });

      // fonction de recherche assuré avec les valeurs null
      this.recuperationDonnees();
    }

    if (event.value === 'date_realisation') {
      this.placeholderInputSearch = 'Rechercher par date';
    }
    if (event.value === 'libelle') {
      this.placeholderInputSearch = 'Rechercher par libelle';
    }
    if (event.value === 'quantite') {
      this.placeholderInputSearch = 'Rechercher par quantité';
    }
    if (event.value === 'pharmacie') {
      this.placeholderInputSearch = 'Rechercher par pharmacie';
    }

    this.formGroup = this.metierService.initialiserFormulaire(this.formGroup.getRawValue());
  }

  recherchePrescriptionRealise(event) {
    if (this.formGroup.getRawValue().selectTypeSearch === null) { return false; }

    // fonction de recherche assuré avec les valeurs entrées
    this.recuperationDonnees();
  }

}
